import { render, staticRenderFns } from "./BrandRegionEditor.vue?vue&type=template&id=5ab00b8c&scoped=true&"
import script from "./BrandRegionEditor.vue?vue&type=script&lang=js&"
export * from "./BrandRegionEditor.vue?vue&type=script&lang=js&"
import style0 from "./BrandRegionEditor.vue?vue&type=style&index=0&id=5ab00b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab00b8c",
  null
  
)

export default component.exports